import AuthService from "./AuthService";
import LoginCtrl from "./LoginCtrl";
import uirouter from "angular-ui-router/release/angular-ui-router";

export default angular
  .module("energis.auth", [uirouter])
  .config(function routes($stateProvider) {
    $stateProvider.state("login", {
      url: "/login",
      views: {
        login: {
          template: require("./login.html"),
          controller: "LoginCtrl",
          controllerAs: "ctrl"
        }
      }
    });
  })
  .service("AuthService", AuthService)
  .controller("LoginCtrl", LoginCtrl)
  .run(function($rootScope, $transitions, AuthService, $interval) {
    console.log("auth");
    $rootScope.auth = AuthService;
    $transitions.onStart({}, function(trans) {
      var $state = trans.router.stateService;
      console.log("on transition");
      if (trans.to().name !== "login") {
        if (!AuthService.isLoggedIn) {
          AuthService.nextState = trans.targetState();
          if (trans.router.urlService.search().loginToken){
            AuthService.tokenLogin(trans.router.urlService.search().loginToken);
          } else {
            return $state.target("login");
          }
          
        }
      }
    });
    //$interval(() => AuthService.keepalive(), 5*60*1000);
  }).name;



// WEBPACK FOOTER //
// ./src/Auth/index.js